
export const Capa = {

    /**
     * Helper function to get the day index (0 = Monday, ..., 6 = Sunday).
     * Returns index 0 to 6 or null (if data is out of week dates range).
     */
    getDayIndex(date, weekDates) {
        const dayIndex = weekDates.findIndex((weekDate) => weekDate === date);
        return dayIndex >= 0 ? dayIndex : null;
    },

    /**
     * Process logic with a callback for the specific functionality.
     */
    processDateRange(startDate, endDate, callback) {
        const currentDate = new Date(startDate);
        const end = new Date(endDate);

        while (currentDate <= end) {
            callback(currentDate.toISOString().split("T")[0]); // Use YYYY-MM-DD format
            currentDate.setDate(currentDate.getDate() + 1);
        }
    },

    /**
     * Calculate crew load and pump usage out of task data fields (start_date, end_date, team_lead_source,
     * team_lead_crew_id and pump_code_key) for the given week dates.
     */
    processTasks(tasks, weekDates) {
        const pumpUsage = new Map();        // Mag <pump_code_key,     [counts by day]>
        const groupLoad = new Map();        // Map <team_lead_crew_id, [counts by day]> for team_lead_source = 0
        const workerLoad = new Map();       // Map <team_lead_crew_id, [counts by day]> for team_lead_source = 1
        const contractorLoad = new Map();   // Map <team_lead_crew_id, [counts by day]> for team_lead_source = 2

        tasks.forEach((task) => {
            const { start_date, end_date, pump_code_key, team_lead_source, team_lead_crew_id } = task;

            // calculate pumpUsage
            if (pump_code_key !== null && pump_code_key !== -1) {
                Capa.processDateRange(start_date, end_date, (date) => {
                    const dayIndex = Capa.getDayIndex(date, weekDates);
                    if (dayIndex !== null) {
                        if (!pumpUsage.has(pump_code_key)) {
                            pumpUsage.set(pump_code_key, [0, 0, 0, 0, 0, 0, 0]);
                        }
                        pumpUsage.get(pump_code_key)[dayIndex]++;
                    }
                });
            }

            // calcualte groupLoad, workerLoad and contractorLoad
            if (team_lead_crew_id !== null) {

                // groupLoad
                if (team_lead_source === 0) {
                    Capa.processDateRange(start_date, end_date, (date) => {
                        const dayIndex = Capa.getDayIndex(date, weekDates);
                        if (dayIndex !== null) {
                            if (!groupLoad.has(team_lead_crew_id)) {
                                groupLoad.set(team_lead_crew_id, [0, 0, 0, 0, 0, 0, 0]);
                            }
                            groupLoad.get(team_lead_crew_id)[dayIndex]++;
                        }
                    });
                }

                // workerLoad
                if (team_lead_source === 1) {
                    Capa.processDateRange(start_date, end_date, (date) => {
                        const dayIndex = Capa.getDayIndex(date, weekDates);
                        if (dayIndex !== null) {
                            if (!workerLoad.has(team_lead_crew_id)) {
                                workerLoad.set(team_lead_crew_id, [0, 0, 0, 0, 0, 0, 0]);
                            }
                            workerLoad.get(team_lead_crew_id)[dayIndex]++;
                        }
                    });
                }

                // contractorLoad
                if (team_lead_source === 2) {
                    Capa.processDateRange(start_date, end_date, (date) => {
                        const dayIndex = Capa.getDayIndex(date, weekDates);
                        if (dayIndex !== null) {
                            if (!contractorLoad.has(team_lead_crew_id)) {
                                contractorLoad.set(team_lead_crew_id, [0, 0, 0, 0, 0, 0, 0]);
                            }
                            contractorLoad.get(team_lead_crew_id)[dayIndex]++;
                        }
                    });
                }
            }
        });

        // return { pumpUsage, groupLoad, workerLoad, contractorLoad };
        return {groupLoad, workerLoad, contractorLoad, pumpUsage };
    },

    getLabel(weekNr) {
        if (weekNr === undefined) {
            return "Einsätze"
        }
        return "Einsätze KW" + weekNr;
    },

    getLoadLabel(loadKey) {
        if (loadKey === "groupLoad") {
            return "Gruppe";
        } else if (loadKey === "workerLoad") {
            return "Arbeiter";
        } else if (loadKey === "contractorLoad") {
            return "Subunternehmer";
        } else if (loadKey === "pumpUsage") {
            return "Pumpen";
        }
        return loadKey;
    },

    getCapaViewSelection() {
        return [
            {label: "Grafisch",  value:0},
            {label: "Numerisch", value:1},
        ]
    }

}
